var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doctena"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":"https://booking-app.doctena.com/fr/doctor/466098af-9514-4183-8b39-197fdbd7ab09/1?","scrolling":"no"}})])
}]

export { render, staticRenderFns }